var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[(_vm.customHomePage)?_c('SlicesBlock',{staticClass:"home-padding",attrs:{"slices":_vm.slices}}):_c('Home')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }